<script lang="ts" setup>
  import { ref, watch } from "vue";

  const props = defineProps<{
    title?: string;
    loading: boolean;
    resetPageTrigger?: boolean;
  }>();

  const slideGroupKey = ref(0);

  watch(() => props.resetPageTrigger, () => {
    slideGroupKey.value = props.resetPageTrigger ? 1 : 0; // this is a force update as there is not something to directly achieve this for v-slide-group
  });
</script>

<template>
  <div class="slider">
    <slot name="title">
      <h2 class="t-title-2 t-bold mb-4 title">
        {{ title ?? '' }}
      </h2>
    </slot>

    <v-slide-group
      :key="slideGroupKey"
      show-arrows
    >
      <slot v-if="loading" name="skeleton"></slot>
      <slot v-else></slot>
    </v-slide-group>
  </div>
</template>

<style lang="scss" scoped>
  .slider {
    position: relative;

    .title {
      height: 1rem;
    }

    :deep(.v-slide-group__content) {
      display: flex;
      flex-wrap: nowrap;
      align-items: flex-start;
      gap: 0.75rem;
    }

    :deep(.v-slide-group__next) {
      transition: 0.5s ease all;
      position: absolute;
      top: 0;
      right: 0;
    }

    :deep(.v-slide-group__prev) {
      transition: 0.5s ease all;
      position: absolute;
      top: 0;
      right: 60px;
    }

    :deep(.v-slide-group__next)::after, :deep(.v-slide-group__prev)::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      border-radius: 50%;
      border: 1px solid rgba(var(--v-theme-on-background), 0.125);
      height: 40px;
      width: 40px;
      z-index: 1;
    }
  }

  @media(max-width: breakpoint(md) - 1px) {
    .slider {
      :deep(.v-slide-group__next), :deep(.v-slide-group__prev) {
        display: none;
      }
    }
  }
</style>
